// extracted by mini-css-extract-plugin
module.exports = {"remarkCopay":"RemarkCopay_remarkCopay__2FuT3","remarkCopayItem":"RemarkCopay_remarkCopayItem__3O4Zr"};